import * as React from 'react';
const ModalDialogVariantColorContext = /*#__PURE__*/React.createContext(undefined);
export default ModalDialogVariantColorContext;